import { render, staticRenderFns } from "./siteCertifyStadard.vue?vue&type=template&id=70320cc2"
import script from "./siteCertifyStadard.vue?vue&type=script&lang=js"
export * from "./siteCertifyStadard.vue?vue&type=script&lang=js"
import style0 from "./siteCertifyStadard.vue?vue&type=style&index=0&id=70320cc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports